import React, { useState, useEffect, useRef } from 'react';

const ParentDocCard = ({ children, ...props }) => {
  const [show, setShow] = useState(false);
  const sidebarRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDocumentation = () => {
    setShow(true);
  };

  const showAlert = (props) => {
    return (
      <div className="alert alert-primary" role="alert">
        <div className="alert-message">
          <strong>Hey there!</strong> {props.alertMessage}
        </div>
      </div>
    );
  };

  const DocsLink = (props) => {
    return (
      <div className="text-left my-1">
        <p>{props.description}</p>
        <a href={props.docLink} target="_blank">
          <u>
            View Docs <i className="webconnect webconnect-box-arrow-up-right"></i>
          </u>
        </a>
      </div>
    );
  };

  const Title = (props) => {
    const { headTitle } = props || '';
    return (
      <h4 className="mb-0 ms-2 d-inline-block">
        <span>{headTitle || 'Documentation'}</span>
      </h4>
    );
  };

  const VideoBox = (props) => {
    const mystyle = {
      width: '17rem',
    };
    const vButton = {
      color: '#1ba7ae6c',
      position: 'absolute',
      top: '50%',
      right: '40%',
      transform: 'translate(-50%,-50%)',
    };
    return (
      <>
        <div className="card-sm">
          <a
            href={props.videoLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ position: 'relative' }}
          >
            <i className="fa fa-caret-right fa-5x" style={vButton}></i>
            <img src={props.imgLink} style={mystyle} alt="img" />
          </a>
        </div>
        <a href={props.videoLink} target="_blank" rel="noopener noreferrer">
          <u>
            {props.videoHeading}
            <i className="webconnect webconnect-box-arrow-up-right pt-2"></i>
          </u>
        </a>
      </>
    );
  };

  const CustomDoc = (props) => {
    const { description, docLink, videoLink, imgLink, videoHeading } = props;
    if (description !== '') {
      return <DocsLink description={description} docLink={docLink} />;
    }
    return (
      <>
        <hr />
        <h5>Video</h5>
        <VideoBox videoLink={videoLink} imgLink={imgLink} videoHeading={videoHeading} />
      </>
    );
  };

  return (
    <>
      <div className={`documentation ${show ? 'open' : ''}`} ref={sidebarRef}>
        <div className="documentation-toggle">
          <div
            className="documentation-toggle-option documentation-toggle-option-text"
            title="Documentation"
            onClick={toggleDocumentation}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            &nbsp; Documentation
          </div>
        </div>
        <div className="documentation-panel">
          <div className="documentation-content">
            <div className="documentation-title d-flex align-items-center">
              <button
                type="button"
                className={`btn-close float-right ${show ? '' : 'open'}`}
                aria-label="Close"
                onClick={handleClose}
              ></button>
              <Title {...props} />
            </div>
            <div className="documentation-body">
              {children ? children : <CustomDoc {...props} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentDocCard;
